export enum SessionStorageKeys {
  Interfaces = '_ua_interfaces',
  TabId = '_ua_tabId',
}
